import React from 'react';
import { HStack, VStack, ScrollView } from '@gluestack-ui/themed';
import { useFormContext } from 'react-hook-form';
import FormField from '@/common/components/forms/FormField';
import SettingsGroupCard from '@/common/components/forms/SettingsGroupCard';
import ObjectIdField from '../../../common/ObjectIdField';
import SegmentsEditor from './SegmentsEditor';

const CourseDetailsForm: React.FC = () => {
  const { watch } = useFormContext();
  const id = watch('id');

  return (
    <ScrollView flex={1} bg="$backgroundLight0">
      <VStack space="xl" py="$6">
        <SettingsGroupCard title="Course Information">
          <VStack space="lg">
            <FormField
              name="title"
              label="Title"
              type="text"
              fieldWidth="100%"
              rules={{ required: 'Course must have a title' }}
            />

            <HStack space="lg" flexWrap="wrap">
              <FormField
                name="language"
                label="Language"
                type="select"
                fieldWidth="180px"
                readonly={!!id}
                choices={[
                  { label: 'English', value: 'en' },
                  { label: 'German', value: 'de' },
                ]}
                rules={{ required: 'Course must have a language' }}
              />
              <FormField
                name="ects"
                label="ECTS Credit Points"
                type="text"
                fieldWidth="140px"
                rules={{
                  required: 'ECTS Credit Points is required',
                  validate: (value: string) => {
                    const numberValue = Number(value);
                    if (Number.isNaN(numberValue)) return 'ECTS must be a number';
                    if (numberValue <= 0) return 'ECTS must be a positive number';
                    return true;
                  },
                }}
              />
              <FormField
                name="state"
                label="State"
                type="select"
                fieldWidth="160px"
                choices={[
                  { label: 'Active', value: 'active' },
                  { label: 'Stale', value: 'stale' },
                  { label: 'Retired', value: 'retired' },
                ]}
                defaultValue="active"
                rules={{ required: 'Course must have a state' }}
              />
              <FormField name="isDeprecated" label="Deprecated" type="switch" defaultValue={false} />
            </HStack>

            <HStack space="lg" flexWrap="wrap">
              <FormField
                name="externalProductId"
                label="CRM Product ID"
                type="text"
                fieldWidth="300px"
                placeholder="e.g. prod_123"
              />
            </HStack>

            <FormField name="description" label="Description" type="textarea" fieldHeight={100} />
          </VStack>
        </SettingsGroupCard>

        <SegmentsEditor courseId={id} />

        <ObjectIdField />
      </VStack>
    </ScrollView>
  );
};

export default CourseDetailsForm;
